<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2">CONTENTS</h2>
<p class="toc"><a class="none" href="#/xhtml/acknowledgments"><span class="smallcaps">ACKNOWLEDGMENTS</span></a></p>
<p class="toc"><a class="none" href="#/xhtml/timeline_of_modjeskas_lifecareer"><span class="smallcaps">TIMELINE OF MODJESKA’S LIFE AND CAREER</span></a></p>
<p class="toc-1"><a class="none" href="#/xhtml/chapter_001">1<br/><em>Debut</em></a></p>
<p class="toc"><a class="none" href="#/xhtml/chapter_002">2<br/><em>The Making of a Polish Actress</em></a></p>
<p class="toc"><span class="none" href="#/xhtml/chapter_003" title="Link target outside of Sample">3<br/><em>Warsaw’s State of the Stars</em></span></p>
<p class="toc"><span class="none" href="#/xhtml/chapter_004" title="Link target outside of Sample">4<br/><em>A Colonial Party and the California Dream</em></span></p>
<p class="toc"><span class="none" href="#/xhtml/chapter_005" title="Link target outside of Sample">5<br/><em>On the American Road</em></span></p>
<p class="toc"><span class="none" href="#/xhtml/chapter_006" title="Link target outside of Sample">6<br/><em>The Roles of Madame Modjeska</em></span></p>
<p class="toc"><span class="none" href="#/xhtml/chapter_007" title="Link target outside of Sample">7<br/><em>The Polish Modjeska</em></span></p>
<p class="toc"><span class="none" href="#/xhtml/chapter_008" title="Link target outside of Sample">8<br/><em>Farewell Tour</em></span></p>
<p class="toc-1"><span class="none" href="#/xhtml/epilogue" title="Link target outside of Sample"><span class="smallcaps">EPILOGUE: FINDING MODJESKA TODAY</span></span></p>
<p class="toc"><span class="none" href="#/xhtml/notes" title="Link target outside of Sample"><span class="smallcaps">NOTES</span></span></p>
<p class="toc"><span class="none" href="#/xhtml/bibliography" title="Link target outside of Sample"><span class="smallcaps">BIBLIOGRAPHY</span></span></p>
<p class="toc"><span class="none" href="#/xhtml/index" title="Link target outside of Sample"><span class="smallcaps">INDEX</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?081d74ac